export const siteConfig = {
  name: "Wise中文网",
  description: "使用 Wise 进行国际汇款，享受透明汇率和低手续费。快速、安全、便捷的跨境支付解决方案。",
  url: "https://www.wise-cn.com",
  // Analytics IDs - Managed via Google Tag Manager
  googleTagManager: "GTM-55CRKBTM",
  googleAnalytics: "G-WBZHH09PD9", // Add this as a GA4 tag in GTM
  microsoftClarity: "scr5nqyr8r", // Add this as a Custom HTML tag in GTM
  plausibleScript: "/js/script.js",
  metadata: {
    title: "Wise官网 | Wise中国 - 汇率、支付、汇款、手续费、中文版介绍",
    description: "Wise官网（Wise中国）为您提供国际汇款、实时汇率、低手续费、跨境支付、Wise中文版、Wise银行账户、货币兑换、全球收款、支付方式等全方位服务。了解Wise汇款官网、Wise转账手续费、Wise货币兑换手续费、Wise可以收哪些货币，轻松开启国际金融新体验。",
    keywords: "Wise, Wise官网, Wise汇率, Wise支付, Wise 中文, Wise银行, Wise 汇款官网, Wise汇款, Wise国际汇款, Wise cn, Wise中国官网, Wise转账手续费, Wise货币兑换手续费, Wise 中文版, Wise换汇, Wise可以收哪些货币, Wise官网介绍, Wise 支付方式, Wise兑换手续费, 国际汇款, 货币兑换, 跨境支付, 低手续费, 透明汇率, 外汇转账",
    author: "Wise中文网",
    ogImage: "/wise-com-screenshot.webp",
    favicon: "/favicon.ico",
    themeColor: "#16a34a",
  },
  links: {
    affiliate: "/visit/wise",
    help: "https://wise.com/help",
    security: "https://wise.com/security",
    legal: "https://wise.com/legal",
    blog: "https://wise.com/blog",
    careers: "https://wise.com/careers",
  },
  social: {
    twitter: "https://twitter.com/Wise",
    facebook: "https://www.facebook.com/Wise",
    instagram: "https://www.instagram.com/wise",
  },
  contact: {
    email: "hi@wise-cn.com",
    support: "https://wise.com/help",
  }
} as const; 
